<template>
  <div class="thank-you-container">
    <div class="thank-you-content">
      <h1>Vielen Dank für Ihre Buchung!</h1>
      <div class="checkmark-container">
        <div class="checkmark">
          <svg class="checkmark-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
            <path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>
      </div>
      <p>Ihre Buchung wurde erfolgreich bestätigt!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThankYou',
  mounted() {
    setTimeout(function () {
      var element = document.querySelector("#booking-container");
      if (element) {
        element.scrollIntoView();
      }
    }, 200);
  }
}
</script>

<style scoped>
.thank-you-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  padding: 2rem;
}

.thank-you-content {
  text-align: center;
  max-width: 500px;
}

.thank-you-content h1 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.thank-you-content p {
  font-size: 1.2rem;
  color: #7f8c8d;
  line-height: 1.6;
  margin-top: 1rem;
}

.checkmark-container {
  margin: 2rem 0;
}

.checkmark-svg {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #27ae60;
  stroke-miterlimit: 10;
  margin: 0 auto;
}

.checkmark-circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: #27ae60;
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark-check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  stroke: #27ae60;
  stroke-width: 3;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}

.checkmark {
  animation: scale 0.3s ease-in-out 0.9s both;
}

@keyframes scale {
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
</style>